export const DEFAULT_PAGE_TITLE = "COVID-19 NSW";
export const DEFAULT_PAGE_DESCRIPTION =
  "See the latest local COVID-19 information for your postcode/suburb/council in New South Wales.";
export const ALL_TIME_START_DATE = "2020-01-25";
export const DELTA_OUTBREAK_START_DATE = "2021-06-16";
export const OMICRON_OUTBREAK_START_DATE = "2021-11-27";
export const POSTCODE_VACCINATIONS_START_DATE = "2021-05-12";
export const COUNCIL_VACCINATIONS_START_DATE = "2021-08-27";
export const SOURCE_TIMEZONE = "Australia/Sydney";
export const VACCINATIONS_NOTE =
  "Based on address at time of vaccination, using ABS 2019 estimated population aged 15+";
export const ALL_TIME_FLAG = "ALL_TIME";
export const SPECIAL_COUNCILS = ["Correctional settings", "Hotel Quarantine"];
